/**
 * Identify the current browser.
 *
 * @param {string} userAgent
 * @return {string}
 */
const detectBrowser = (userAgent) => {
  if (new RegExp(/Firefox\/(\d){2,}/).test(userAgent)) {
    return 'firefox'
  }
  if (new RegExp(/Edg\/(\d){2,}/).test(userAgent)) {
    return 'edge'
  }
  if (new RegExp(/OPR\/(\d)+/).test(userAgent)) {
    return 'opera'
  }
  if (new RegExp(/Chrome\/(\d){2,}/).test(userAgent)) {
    return 'chrome'
  }
  if (new RegExp(/Version\/\d+\.\d+(\.\d+)?\s(Mobile\/(\w|\d)+\s)?Safari\/\d{2,}/).test(userAgent)) {
    return 'safari'
  }

  return 'other'
}

export default detectBrowser
